import { render, staticRenderFns } from "./AddKta.vue?vue&type=template&id=323bf7ca&"
import script from "./AddKta.vue?vue&type=script&lang=js&"
export * from "./AddKta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports